import { projectEmployeeSortConstants } from '../constant/totalRecord.constants';
import { projectEmployeeSort } from '../services/totalRecord.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getProjectEmployeeSort = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        projectEmployeeSort.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(projectEmployeeSortList) { 
        return { type:  projectEmployeeSortConstants.GET_SUCCESS, projectEmployeeSortList }; 
    }
}
